/**
 * Gajica → srpska ćirilica (reč po reč, Đž/Lj/Nj pre pojedinačnih slova).
 * Ne dira URL-ove, domen-e i email (koristi se u latinToCyrillicMarkdown).
 */

const UPPER: Record<string, string> = {
  A: 'А',
  B: 'Б',
  C: 'Ц',
  Č: 'Ч',
  Ć: 'Ћ',
  D: 'Д',
  Đ: 'Ђ',
  E: 'Е',
  F: 'Ф',
  G: 'Г',
  H: 'Х',
  I: 'И',
  J: 'Ј',
  K: 'К',
  L: 'Л',
  M: 'М',
  N: 'Н',
  O: 'О',
  P: 'П',
  R: 'Р',
  S: 'С',
  Š: 'Ш',
  T: 'Т',
  U: 'У',
  V: 'В',
  Z: 'З',
  Ž: 'Ж',
};

const LOWER: Record<string, string> = {
  a: 'а',
  b: 'б',
  c: 'ц',
  č: 'ч',
  ć: 'ћ',
  d: 'д',
  đ: 'ђ',
  e: 'е',
  f: 'ф',
  g: 'г',
  h: 'х',
  i: 'и',
  j: 'ј',
  k: 'к',
  l: 'л',
  m: 'м',
  n: 'н',
  o: 'о',
  p: 'п',
  r: 'р',
  s: 'с',
  š: 'ш',
  t: 'т',
  u: 'у',
  v: 'в',
  z: 'з',
  ž: 'ж',
};

/**
 * Anglizmi gde pravilo C→Ц daje pogrešan zapis; zameniti pre slogovskog preslikavanja.
 * Npr. "Coworking" → "Коворкинг", ne "Цоwоркинг" (w nije u Gajici, ostaje latinica).
 */
function replaceLoanwordsBeforeGajica(input: string): string {
  return input.replace(/\bcoworking\b/gi, (m) => {
    /** Samo ako je ceo string velikim slovima (npr. COWORKING), ne i za Coworking / coworking. */
    if (m === 'COWORKING') return 'КОВОРКИНГ';
    return m[0] === 'C' || m[0] === 'c' ? (m[0] === 'C' ? 'Коворкинг' : 'коворкинг') : m;
  });
}

export function latinToCyrillicSerbian(input: string): string {
  const src = replaceLoanwordsBeforeGajica(input);
  let out = '';
  let i = 0;
  while (i < src.length) {
    const c = src[i];
    const next = src[i + 1] ?? '';

    if (c === 'D' && (next === 'ž' || next === 'Ž')) {
      out += 'Џ';
      i += 2;
      continue;
    }
    if (c === 'd' && next === 'ž') {
      out += 'џ';
      i += 2;
      continue;
    }
    if ((c === 'L' && next === 'j') || (c === 'L' && next === 'J')) {
      out += 'Љ';
      i += 2;
      continue;
    }
    if (c === 'l' && next === 'j') {
      out += 'љ';
      i += 2;
      continue;
    }

    if ((c === 'N' && next === 'j') || (c === 'N' && next === 'J')) {
      out += 'Њ';
      i += 2;
      continue;
    }
    if (c === 'n' && next === 'j') {
      out += 'њ';
      i += 2;
      continue;
    }

    if (UPPER[c]) {
      out += UPPER[c];
      i += 1;
      continue;
    }
    if (LOWER[c]) {
      out += LOWER[c];
      i += 1;
      continue;
    }

    out += c;
    i += 1;
  }
  return out;
}

const URL_RE = /https?:\/\/[^\s<>\])'"]+/gi;
const EMAIL_RE = /[^\s<>\])'"]+@[^\s<>\])'"]+/gi;
const DOMAIN_RE = /\b[\w.-]+\.(rs|com|org|eu|net|gov|co)\b/gi;

/**
 * Konvertuje latinicu u ćirilicu u markdownu, čuvajući URL-ove, domene i email.
 */
export function latinToCyrillicMarkdown(md: string): string {
  const protectedChunks: string[] = [];
  let s = md;
  const shield = (re: RegExp) => {
    s = s.replace(re, (m) => {
      protectedChunks.push(m);
      return `\uE000${protectedChunks.length - 1}\uE001`;
    });
  };
  shield(URL_RE);
  shield(EMAIL_RE);
  shield(DOMAIN_RE);

  s = latinToCyrillicSerbian(s);

  for (let i = protectedChunks.length - 1; i >= 0; i--) {
    s = s.replace(`\uE000${i}\uE001`, protectedChunks[i]);
  }
  return s;
}
